import { AuthenticationError } from '~/errors/AuthenticationError';
import { useAuthentication } from '~/hooks/useAuthentication';
import { User } from '~/apis/ssf';

export interface WithAuthenticationProps {
  user: User;
}

export function withAuthentication<T extends WithAuthenticationProps = WithAuthenticationProps>(
  WrappedComponent: React.ComponentType<T>
) {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const ComponentWithAuthentication = (props: Omit<T, keyof WithAuthenticationProps>) => {
    const { isAuthenticated, user } = useAuthentication();

    if (!isAuthenticated) {
      throw new AuthenticationError();
    }

    return <WrappedComponent {...(props as T)} user={user} />;
  };

  ComponentWithAuthentication.displayName = `withAuthentication(${displayName})`;

  return ComponentWithAuthentication;
}
